import { render } from "./InvitationMenu.vue?vue&type=template&id=170a6dd3"
import script from "./InvitationMenu.vue?vue&type=script&lang=js"
export * from "./InvitationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__